module.exports = __webpack_public_path__ + "layers-2x.png?4f0283c6ce28e888000e978e537a6a56";